import { createContext, useContext } from "react";
import type { SessionUser, Role } from "@/types/session";

type AuthContextValue = {
  user: SessionUser | null;
  loading: boolean;
  hasRole: (...roles: Role[]) => boolean;
};

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside <AuthProvider>");
  return ctx;
}
